/*!
 * KAVRAH Pair Builder — Buy 1, Get 1 Free
 * Growth Pulse Media · v1.0 · no app, no dependencies
 *
 * Reads every scent from /collections/<handle>/products.json, lets the
 * customer fill two bottle slots, then adds ONE pair variant to the cart
 * with the chosen scents as line item properties.
 */
(function () {
  'use strict';

  var CHIP_TAGS = ['For Her', 'For Him', 'Unisex', 'Oud & Woody', 'House Fragrance'];
  var POPULAR = ['kavrah-tobacco-vanille', 'kavrah-ysl-libre', 'kavrah-sauvage', 'kavrah-good-girl'];
  var cache = {};

  function norm(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }
  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // "100ml + Free Delivery" -> "100ml"
  function sizeKey(v) {
    return norm(v).trim().split(/\s+/)[0];
  }
  function parseTitle(title) {
    var m = String(title).match(/["“]([^"”]+)["”]/);
    if (m) return { name: m[1].trim(), kind: 'Inspired by' };
    var first = String(title).split('|')[0].replace(/^\s*kavrah\s+/i, '').trim();
    var pretty = first.toLowerCase().replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); });
    return { name: 'Kavrah ' + pretty, kind: 'House fragrance' };
  }
  function imgUrl(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function track(evt, data) {
    try { if (window.fbq) window.fbq('trackCustom', evt, data); } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: evt };
      for (var k in data) o[k] = data[k];
      window.dataLayer.push(o);
    } catch (e) {}
  }

  function loadScents(root, handle) {
    var key = root + '|' + handle;
    if (cache[key]) return cache[key];
    cache[key] = (async function () {
      var out = [];
      for (var page = 1; page <= 4; page++) {
        var url = root + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + page;
        var r = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!r.ok) throw new Error('Scents could not load (' + r.status + ')');
        var d = await r.json();
        var list = d.products || [];
        list.forEach(function (p) {
          var t = parseTitle(p.title);
          var tags = (Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(','))
            .map(function (x) { return String(x).trim(); }).filter(Boolean);
          var variants = {};
          (p.variants || []).forEach(function (v) {
            variants[sizeKey(v.option1 || v.title)] = { id: v.id, sku: v.sku || '', available: v.available !== false };
          });
          var skus = Object.keys(variants).map(function (k) { return variants[k].sku; }).join(' ');
          out.push({
            handle: p.handle, title: p.title, name: t.name, kind: t.kind, tags: tags,
            img: p.images && p.images[0] ? p.images[0].src : '',
            variants: variants,
            search: norm([t.name, p.title, tags.join(' '), skus].join(' '))
          });
        });
        if (list.length < 250) break;
      }
      out.sort(function (a, b) { return a.name.localeCompare(b.name); });
      return out;
    })();
    cache[key].catch(function () { delete cache[key]; });
    return cache[key];
  }

  function PairBuilder(el) {
    var self = this;
    this.el = el;
    this.root = (el.dataset.root || '/').replace(/\/?$/, '/');
    this.handle = el.dataset.collection || 'build-your-own-bogo';
    this.cartAdd = (el.dataset.cartAddUrl || this.root + 'cart/add') + '.js';
    this.cartUrl = el.dataset.cartUrl || this.root + 'cart';
    this.afterAdd = el.dataset.afterAdd || 'cart';
    this.freeFrom = parseInt(el.dataset.freeFrom || '49900', 10);
    this.noteFee = el.dataset.noteFee || '';
    this.noteFree = el.dataset.noteFree || '';
    this.variants = JSON.parse(el.querySelector('[data-kpb-variants]').textContent);
    this.slots = [null, null];
    this.scents = null;
    this.q = '';
    this.filter = 'All';
    this.active = 0;
    this.busy = false;

    this.drawer = el.querySelector('[data-kpb-drawer]');
    this.sticky = el.querySelector('[data-kpb-sticky]');
    document.body.appendChild(this.drawer);
    if (this.sticky) document.body.appendChild(this.sticky);
    this.grid = this.drawer.querySelector('[data-kpb-grid]');
    this.search = this.drawer.querySelector('[data-kpb-search]');
    this.chips = this.drawer.querySelector('[data-kpb-chips]');
    this.count = this.drawer.querySelector('[data-kpb-count]');
    this.cta = el.querySelector('[data-kpb-add]');
    this.errorEl = el.querySelector('[data-kpb-error]');

    this.bind();
    var params = new URLSearchParams(location.search);
    this.setSize(this.initialSize(params), false);
    this.renderSlots();
    el.classList.add('is-ready');
    var pre = params.get('scent');
    if (pre) this.prefill(pre);
  }

  PairBuilder.prototype.initialSize = function (params) {
    var self = this;
    var want = params.get('size');
    var byKey = function (k) {
      return self.variants.filter(function (v) { return v.size === k && v.available; })[0];
    };
    if (want && byKey(sizeKey(want))) return sizeKey(want);
    var vid = params.get('variant');
    if (vid) {
      var m = this.variants.filter(function (v) { return String(v.id) === vid && v.available; })[0];
      if (m) return m.size;
    }
    var def = sizeKey(this.el.dataset.defaultSize || '50ml');
    if (byKey(def)) return def;
    var first = this.variants.filter(function (v) { return v.available; })[0] || this.variants[0];
    return first.size;
  };

  PairBuilder.prototype.bind = function () {
    var self = this;
    this.el.querySelectorAll('[data-kpb-size]').forEach(function (b) {
      b.addEventListener('click', function () { self.setSize(b.dataset.kpbSize, true); });
    });
    this.el.querySelectorAll('[data-kpb-slot]').forEach(function (b) {
      b.addEventListener('click', function () { self.open(parseInt(b.dataset.kpbSlot, 10)); });
    });
    this.cta.addEventListener('click', function () {
      if (self.filled() === 2) return self.add();
      self.open(self.slots[0] ? 1 : 0);
    });
    if (this.sticky) {
      this.sticky.querySelector('[data-kpb-sticky-btn]').addEventListener('click', function () {
        if (self.filled() === 2) return self.add();
        self.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        self.open(self.slots[0] ? 1 : 0);
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          self.sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
        }).observe(this.cta);
      }
    }
    this.drawer.querySelectorAll('[data-kpb-close]').forEach(function (b) {
      b.addEventListener('click', function () { self.close(); });
    });
    var t;
    this.search.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () { self.q = self.search.value; self.renderGrid(); }, 120);
    });
    this.grid.addEventListener('click', function (e) {
      var card = e.target.closest('[data-handle]');
      if (card) self.select(card.dataset.handle);
    });
    this.chips.addEventListener('click', function (e) {
      var c = e.target.closest('[data-chip]');
      if (!c) return;
      self.filter = c.dataset.chip;
      self.renderChips();
      self.renderGrid();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !self.drawer.hidden) self.close();
    });
    this.drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = self.drawer.querySelectorAll('button, input, [tabindex="0"]');
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    var pres = this.el.querySelector('[data-kpb-presets]');
    if (pres) {
      pres.addEventListener('click', function (e) {
        var b = e.target.closest('[data-kpb-preset]');
        if (!b) return;
        loadScents(self.root, self.handle).then(function (list) {
          self.scents = list;
          var picked = b.dataset.kpbPreset.split(',').map(function (h) {
            return list.filter(function (x) { return x.handle === h.trim(); })[0];
          }).filter(function (s) { return s && s.variants[self.size] && s.variants[self.size].available; });
          if (picked.length < 2) { self.showError('This pair is not available in ' + self.size + '. Choose your scents by hand.'); return; }
          self.slots = [picked[0], picked[1]];
          self.showError('');
          self.renderSlots();
          track('kavrah_preset_pair', { preset: b.textContent.trim(), pair_size: self.size });
        }).catch(function () { self.showError('The scents could not load. Please refresh the page.'); });
      });
    }
  };

  PairBuilder.prototype.variantFor = function (size) {
    return this.variants.filter(function (v) { return v.size === size; })[0];
  };
  PairBuilder.prototype.filled = function () {
    return this.slots.filter(Boolean).length;
  };

  PairBuilder.prototype.setSize = function (size, updateUrl) {
    var v = this.variantFor(size);
    if (!v || !v.available) return;
    this.size = size;
    this.variant = v;
    this.el.querySelectorAll('[data-kpb-size]').forEach(function (b) {
      var on = b.dataset.kpbSize === size;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    this.el.querySelectorAll('[data-kpb-size-label]').forEach(function (n) { n.textContent = size; });
    this.el.querySelector('[data-kpb-price]').textContent = v.price;
    var cmp = this.el.querySelector('[data-kpb-compare]');
    cmp.textContent = v.compareCents > v.priceCents ? v.compare : '';
    cmp.hidden = !(v.compareCents > v.priceCents);
    this.el.querySelector('[data-kpb-delivery]').textContent = v.priceCents >= this.freeFrom ? this.noteFree : this.noteFee;
    var bnpl = this.el.querySelector('[data-kpb-bnpl-amt]');
    if (bnpl) bnpl.textContent = 'R' + (Math.floor(v.priceCents / 6) / 100).toFixed(2);
    if (this.sticky) this.sticky.querySelector('[data-kpb-sticky-price]').textContent = v.price;

    var dropped = [];
    var self = this;
    this.slots = this.slots.map(function (s) {
      if (s && !(s.variants[self.size] && s.variants[self.size].available)) { dropped.push(s.name); return null; }
      return s;
    });
    this.showError(dropped.length
      ? dropped.join(' and ') + ' is not available in ' + size + '. Choose another scent.'
      : '');
    this.renderSlots();
    if (!this.drawer.hidden && this.scents) this.renderGrid();
    if (updateUrl && window.history && history.replaceState) {
      var u = new URL(location.href);
      u.searchParams.set('size', size);
      u.searchParams.delete('variant');
      history.replaceState(history.state, '', u.toString());
    }
  };

  PairBuilder.prototype.renderSlots = function () {
    var self = this;
    this.el.querySelectorAll('[data-kpb-slot]').forEach(function (b) {
      var i = parseInt(b.dataset.kpbSlot, 10);
      var s = self.slots[i];
      b.classList.toggle('is-filled', !!s);
      b.querySelector('[data-kpb-slot-img]').innerHTML = s && s.img
        ? '<img src="' + esc(imgUrl(s.img, 160)) + '" alt="" loading="lazy" width="80" height="80">' : '';
      b.querySelector('[data-kpb-slot-kind]').textContent = s ? s.kind : '';
      b.querySelector('[data-kpb-slot-name]').textContent = s ? s.name : 'Choose your scent';
      b.querySelector('[data-kpb-slot-action]').textContent = s ? 'Change' : 'Choose';
      b.setAttribute('aria-label', (i === 0 ? 'Bottle 1' : 'Bottle 2, free') + ': ' + (s ? s.name + '. Change scent' : 'choose a scent'));
    });
    var n = this.filled();
    this.el.querySelector('[data-kpb-progress]').textContent = n + ' of 2 chosen';
    var price = this.variant ? this.variant.price : '';
    var label = n === 2 ? 'Add my pair · ' + price
      : n === 1 ? 'Choose your 2nd scent — free' : 'Choose my first scent';
    this.cta.disabled = this.busy;
    this.cta.querySelector('[data-kpb-add-label]').textContent = this.busy ? 'Adding…' : label;
    if (this.sticky) {
      this.sticky.querySelector('[data-kpb-sticky-btn]').textContent = n === 2 ? 'Add pair to cart' : 'Choose scents';
    }
  };

  PairBuilder.prototype.open = function (i) {
    var self = this;
    this.active = i;
    this.lastFocus = document.activeElement;
    this.drawer.querySelector('[data-kpb-for]').textContent = i === 0 ? 'Bottle 1' : 'Bottle 2 · Free';
    this.drawer.querySelector('[data-kpb-for-size]').textContent = this.size;
    // Fresh start each time: no old search text or filter hides scents.
    this.q = ''; this.search.value = ''; this.filter = 'All';
    this.grid.scrollTop = 0;
    this.drawer.hidden = false;
    document.documentElement.classList.add('kpb-lock');
    requestAnimationFrame(function () { self.drawer.classList.add('is-open'); });
    // Desktop: focus search. Touch: focus the panel, so the keyboard does not cover the list.
    var touch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    (touch ? this.drawer.querySelector('.kpb-drawer__panel') : this.search).focus({ preventScroll: true });
    if (this.scents) { this.renderChips(); return this.renderGrid(); }
    this.grid.innerHTML = '<p class="kpb-drawer__msg">Loading scents…</p>';
    loadScents(this.root, this.handle).then(function (list) {
      self.scents = list;
      self.renderChips();
      self.renderGrid();
    }).catch(function () {
      self.grid.innerHTML = '<p class="kpb-drawer__msg">The scents could not load. Please refresh the page.</p>';
    });
  };

  PairBuilder.prototype.close = function () {
    var self = this;
    this.drawer.classList.remove('is-open');
    document.documentElement.classList.remove('kpb-lock');
    setTimeout(function () { self.drawer.hidden = true; }, 260);
    var back = this.el.querySelector('[data-kpb-slot="' + this.active + '"]');
    if (back) back.focus({ preventScroll: true });
  };

  PairBuilder.prototype.available = function () {
    var size = this.size;
    return (this.scents || []).filter(function (s) { return s.variants[size] && s.variants[size].available; });
  };

  PairBuilder.prototype.renderChips = function () {
    var self = this;
    var present = {};
    this.available().forEach(function (s) { s.tags.forEach(function (t) { present[t] = 1; }); });
    var chips = ['All'].concat(CHIP_TAGS.filter(function (t) { return present[t]; }));
    this.chips.innerHTML = chips.map(function (c) {
      return '<button type="button" class="kpb-chip' + (c === self.filter ? ' is-active' : '') +
        '" data-chip="' + esc(c) + '" aria-pressed="' + (c === self.filter) + '">' + esc(c) + '</button>';
    }).join('');
  };

  PairBuilder.prototype.renderGrid = function () {
    var self = this;
    var words = norm(this.q).split(/\s+/).filter(Boolean);
    var other = this.slots[this.active === 0 ? 1 : 0];
    var current = this.slots[this.active];
    var list = this.available().filter(function (s) {
      if (self.filter !== 'All' && s.tags.indexOf(self.filter) < 0) return false;
      return words.every(function (w) { return s.search.indexOf(w) > -1; });
    });
    var unfiltered = !words.length && this.filter === 'All';
    if (unfiltered) {
      var pop = POPULAR.map(function (h) { return list.filter(function (x) { return x.handle === h; })[0]; }).filter(Boolean);
      list = pop.concat(list.filter(function (x) { return POPULAR.indexOf(x.handle) < 0; }));
    }
    this.count.textContent = unfiltered
      ? "100's of scents to choose from"
      : list.length + (list.length === 1 ? ' match' : ' matches');
    if (!list.length) {
      this.grid.innerHTML = '<p class="kpb-drawer__msg">No scents match. Try another name or filter.</p>';
      return;
    }
    this.grid.innerHTML = list.map(function (s) {
      var sel = current && current.handle === s.handle;
      var note = other && other.handle === s.handle ? '<span class="kpb-card__note">In bottle ' + (self.active === 0 ? 2 : 1) + '</span>' : '';
      return '<button type="button" class="kpb-card' + (sel ? ' is-selected' : '') + '" data-handle="' + esc(s.handle) + '" aria-pressed="' + sel + '">' +
        '<span class="kpb-card__img">' + (s.img ? '<img src="' + esc(imgUrl(s.img, 300)) + '" alt="" loading="lazy" width="150" height="150">' : '') + note + (POPULAR.indexOf(s.handle) > -1 ? '<span class="kpb-card__pop">Popular</span>' : '') + '</span>' +
        '<span class="kpb-card__kind">' + esc(s.kind) + '</span>' +
        '<span class="kpb-card__name">' + esc(s.name) + '</span>' +
        '<span class="kpb-card__select">' + (sel ? 'Selected' : 'Select') + '</span>' +
        '</button>';
    }).join('');
  };

  PairBuilder.prototype.select = function (handle) {
    var s = (this.scents || []).filter(function (x) { return x.handle === handle; })[0];
    if (!s) return;
    this.slots[this.active] = s;
    this.showError('');
    this.renderSlots();
    track('SelectItem', { pair_size: this.size, bottle: this.active + 1, sku: s.variants[this.size].sku });
    this.close();
    var next = this.slots[0] ? (this.slots[1] ? null : 1) : 0;
    if (next !== null) {
      var n = this.el.querySelector('[data-kpb-slot="' + next + '"]');
      n.classList.add('is-next');
      setTimeout(function () { n.classList.remove('is-next'); }, 1600);
    }
  };

  PairBuilder.prototype.prefill = function (handle) {
    var self = this;
    loadScents(this.root, this.handle).then(function (list) {
      self.scents = list;
      var s = list.filter(function (x) { return x.handle === handle; })[0];
      if (s && s.variants[self.size] && s.variants[self.size].available && !self.slots[0]) {
        self.slots[0] = s;
        self.renderSlots();
      }
    }).catch(function () {});
  };

  PairBuilder.prototype.showError = function (msg) {
    this.errorEl.textContent = msg;
    this.errorEl.hidden = !msg;
  };

  PairBuilder.prototype.add = function () {
    var self = this;
    if (this.filled() !== 2 || this.busy) return;
    var size = this.size;
    var line = function (s) {
      return (s.kind === 'Inspired by' ? 'Inspired by ' : '') + s.name + ' — ' + s.variants[size].sku;
    };
    var body = {
      items: [{
        id: this.variant.id,
        quantity: 1,
        properties: { 'Bottle 1': line(this.slots[0]), 'Bottle 2': line(this.slots[1]), '_pair_size': size }
      }]
    };
    this.busy = true;
    this.showError('');
    this.renderSlots();
    fetch(this.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, d: d }; });
    }).then(function (res) {
      if (!res.ok) throw new Error(res.d.description || res.d.message || 'This pair could not be added.');
      track('kavrah_pair_add', {
        pair_size: size, value: self.variant.priceCents / 100,
        skus: [self.slots[0].variants[size].sku, self.slots[1].variants[size].sku]
      });
      document.dispatchEvent(new CustomEvent('kavrah:pair-added', { detail: { cart: res.d, size: size } }));
      if (self.afterAdd === 'cart') { window.location.href = self.cartUrl; return; }
      self.busy = false;
      self.slots = [null, null];
      self.renderSlots();
    }).catch(function (err) {
      self.busy = false;
      self.renderSlots();
      self.showError(err.message);
    });
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-kpb]:not(.is-ready)').forEach(function (el) {
      try { new PairBuilder(el); } catch (e) { if (window.console) console.error('Kavrah pair builder:', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
